export enum TipoCorreo {
	Registro = 1,
	RecuperarClave = 2,
	AsignacionSolicitud = 3,
	Contactenos = 4,
	SolicitudEvaluada = 5,
	NotificacionTareaProgramada = 6
}
